import { h } from 'preact';
import React, { Component } from 'react';
import Toggle from '../Components/Toggle';
import Switch from '../Components/Switch';
import { makeText, formatDescription, isActionAllowed } from '../../../util';

export default class StackToggle extends Component {
  state = {
    open: false,
    consentAll: false,
    liAll: false
  }
  toggleAccordion = () => {
    const content = this.content;
    const open = !this.state.open;
    this.setState({ open }, this.props.force);
    if (!open) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
    }

  }
  shouldComponentUpdate(nextProps, nextState) {
    const content = this.content;
    const open = nextState.open;
    if (content && open) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  }
  toggleConsentAll = () => {
    const consentAll = !this.state.consentAll;
    this.setState({ consentAll }, this.props.force);
  }
  toggleLiAll = () => {
    const liAll = !this.state.liAll;
    this.setState({ liAll }, this.props.force);
  }
  openLink = () => window.open(this.props.vendor.policyUrl, '_blank');
  render() {
    const { purpose, selected, settings, togglePurposeOrFeature, toggleText, toggleOffText, language, force, dev, parentAccordionOpen, usePurModel } = this.props;
    const { open, consentAll, liAll } = this.state;

    const viewAllText = makeText(Boolean(dev), settings, 'viewAllText', language);
    const viewLessText = makeText(Boolean(dev), settings, 'viewLessText', language);
    const otherText = makeText(Boolean(dev), settings, 'otherText', language);
    const otherLetter = makeText(Boolean(dev), settings, 'otherLetter', language);
    const customPurposesLetter = makeText(Boolean(dev), settings, 'customPurposesLetter', language);
    const vendorTitleText = makeText(Boolean(dev), settings, 'vendorTitleText', language);

    const tabIndex = parentAccordionOpen ? 0 : -1;
    return (
      <div className="toggle-purpose">
        <div className="stack-row" style={{ position: 'relative' }}>
          <div
            tabIndex={tabIndex}
            className={open ? 'opener active' : 'opener'}
            onClick={this.toggleAccordion}
            onKeyDown={e => isActionAllowed(e.key) && this.toggleAccordion()}
          >
            <span className="plusminus">{open ? '-' : '+'}</span>
            <span>{purpose.name}{purpose.type === 'CUSTOM' && <span className="legend-key inline" aria-hidden>{customPurposesLetter}</span>}</span>
          </div>
          {togglePurposeOrFeature && (
            <Switch
              tabbable={tabIndex == 0}
              type={settings.toggleType}
              color={settings.toggleColor}
              colorActive={settings.toggleActiveColor}
              offColor={settings.toggleOffColor}
              offActiveColor={settings.toggleOffActiveColor}
              text={toggleText}
              offText={toggleOffText}
              toggle={togglePurposeOrFeature}
              child="purposes"
              vendors={selected === 'consent' ? purpose.requiringConsentVendors : purpose.legIntVendors}
              value={purpose}
              legInt={selected === 'li' ? true : false}
              checked={selected === 'li' ? purpose.legInt : purpose.active}
              usePurModel={usePurModel}
            />
          )}
        </div>
        <div ref={c => this.content = c} className="main">
          <p className="sub-purpose-description">{formatDescription(purpose.description)}</p>
          {selected === 'consent' && (
            <div className="inner-main">
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                {purpose.requiringConsentVendors.length} {vendorTitleText}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <div className="legend">
                    <span className="legend-key" aria-hidden>
                      {otherLetter}
                    </span>
                  </div>
                  <h2 class="custom-header">
                    {otherText}
                  </h2>
                </div>
              </div>
              {purpose.requiringConsentVendors.slice(0, consentAll ? purpose.requiringConsentVendors.length : 3)
                .map((v) => (
                  <Toggle
                    vendor={v}
                    key={v.vendorId}
                    language={language}
                    settings={settings}
                    force={force}
                    accordionOpen={open}
                  />
                ))}
              {purpose.requiringConsentVendors.length > 3 ? (
                <div
                  className="view-all"
                  role="button"
                  onClick={this.toggleConsentAll}
                >
                  {consentAll ? viewLessText : viewAllText}
                </div>
              ) : null}
            </div>
          )}
          {selected === 'li' && (
            <div className="inner-main">
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div className="pv-title">{purpose.legIntVendors.length} {vendorTitleText}</div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div className="legend">
                    <span className="legend-key" aria-hidden>
                      {otherLetter}
                    </span>
                    <h2 class="custom-header">
                      {otherText}
                    </h2>
                  </div>
                </div>
              </div>
              {purpose.legIntVendors.slice(0, liAll ? purpose.legIntVendors.length : 3)
                .map((v) => (
                  <Toggle
                    vendor={v}
                    key={v.vendorId}
                    language={language}
                    settings={settings}
                    force={force}
                    accordionOpen={open}
                  />
                ))}
              {purpose.legIntVendors.length > 3 ? (
                <div
                  className="view-all"
                  role="button"
                  onClick={this.toggleLiAll}
                >
                  {liAll ? viewLessText : viewAllText}
                </div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    );
  }
}